<div class="p-fluid">
  <div class="p-field">
    <label kodit-form-label>{{label}}</label>
    <p-selectButton
      [options]="options"
      [(ngModel)]="value"
      (onOptionClick)="handleValueChanged(value)"
    >
    </p-selectButton>
  </div>
</div>
